import React, { Component } from "react";
import {
  Button,
  Table,
  Col,
  Input,
  Row,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Select from 'react-select';
import Pagination from "react-js-pagination";
import * as bacLuongUserConstant from './constants'
import * as bacLuongUserAction from './actions'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { CheckboxExt } from "../controls/CheckboxExt"
class BacLuongUser extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      StoreId: dbContext.getStoreId(),
      item: {},
      listUser: [],
      usersUnset: [],
      usersSetted: [],
      keyword: '',
      selectedOption: null,
      BacLuongId: 0,
      formError: [],
      page: 1,
      per_page: 20,
      total_record: 0,
      UserIds: [],
      UnUserIds: [],
      selectedAll: false,
      selectedAllUn: false
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.featchDetail);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  checkedUnUserAll = () => {
    let { usersUnset, UserIds, selectedAll } = this.state;
    selectedAll = !selectedAll;
    UserIds = [];
    if (selectedAll) {
      if (usersUnset && usersUnset.length > 0) {
        usersUnset.map((res, idx) => (
          UserIds.push(res.UserId)
        ))
      }
    } else {
      UserIds = []
    }
    this.setState({ UserIds, selectedAll }, () => {
      $('.cb-item').prop('checked', selectedAll);
    });
  }
  CheckedUserAll = () => {
    let { usersSetted, UnUserIds, selectedAllUn } = this.state;
    selectedAllUn = !selectedAllUn;
    UnUserIds = [];
    if (selectedAllUn) {
      if (usersSetted && usersSetted.length > 0) {
        usersSetted.map((res, idx) => (
          UnUserIds.push(res.UserId)
        ))
      }
    } else {
      UnUserIds = []
    }
    this.setState({ UnUserIds, selectedAllUn }, () => {
      $('.cb-item-un').prop('checked', selectedAllUn);
    });
  }

  handleUserClick(option) {
    let { UserIds } = this.state;
    var index = UserIds.indexOf(option.UserId);
    if (index !== -1) {
      UserIds.splice(index, 1);
    }
    else {
      UserIds.push(
        option.UserId
      );
    }
    this.setState({ UserIds, selectedAll: false });
    $('.cb-item-all').prop('checked', false)
  }
  handleUnUserClick(option) {
    let { UnUserIds } = this.state;
    var index = UnUserIds.indexOf(option.UserId);
    if (index !== -1) {
      UnUserIds.splice(index, 1);
    }
    else {
      UnUserIds.push(
        option.UserId
      );
    }
    $('.cb-item-un-all').prop('checked', false)
    this.setState({ UnUserIds, selectedAllUn: false });
  }
  handleBacLuongChange = selectedOption => {
    this.setState({ selectedOption });
    this.setState({ BacLuongId: selectedOption.value, formError: "" }, () => {
      this.featchDetail();
    });
  };
  featchDetail = () => {
    const { bacLuongUserListRequest } = this.props
    $('.cb-item').prop('checked', false);
    $('.cb-item-all').prop('checked', false);
    $('.cb-item-un').prop('checked', false);
    $('.cb-item-un-all').prop('checked', false);
    this.setState({ selectedAll: false, selectedAllUn: false, UserIds: [], UnUserIds: [] });
    var requestData = {
      keyword: this.state.keyword,
      StoreId: this.state.StoreId,
      BacLuongId: this.state.BacLuongId,
      page: this.state.page,
      per_page: this.state.per_page
    }
    return bacLuongUserListRequest(requestData);
  }
  fetchListBacLuong = () => {
    const { bacLuongUserDetailRequest } = this.props
    var requestData = {
      store: this.state.StoreId
    };
    return bacLuongUserDetailRequest(requestData);
  }
  filterUsersSetted = (event) => {
    var updatedList = this.props.bacLuongUser.item.usersSetted;
    updatedList = updatedList.filter(function (item) {
      return (
        item.username != null && item.username.toLowerCase().search(event.target.value.toLowerCase()) !== -1 ||
        item.TenDayDu != null && item.TenDayDu.toLowerCase().search(event.target.value.toLowerCase()) !== -1 ||
        item.DienThoai != null && item.DienThoai.toLowerCase().search(event.target.value.toLowerCase()) !== -1
      )
    });
    this.setState({ usersSetted: updatedList })
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.featchDetail()
    }
  }
  updateUsersSetted = (flag) => {
    let { formError, UserIds, UnUserIds } = this.state;
    var listUser = []
    if (flag == "add") {
      listUser = UserIds
      if (listUser.length <= 0) {
        return;
      }
    }
    if (flag == "remove") {
      listUser = UnUserIds
      if (listUser.length <= 0) {
        return;
      }
    }
    formError = [];
    if (this.state.BacLuongId && this.state.BacLuongId > 0) {
      var requestData = {
        StoreId: this.state.StoreId,
        BacLuongId: this.state.BacLuongId || 0,
        UserIds: listUser,
        Type: flag == "add" ? 0 : 1
      }
      this.props.bacLuongUserUpdateRequest(requestData);
    } else {
      formError.BacLuongId = "Bạn chưa chọn bậc lương";
    }
    this.setState({ formError: formError });
  }

  UpdateBacLuongUser = (res, flag) => {
    var formError = this.state.formError;
    formError = [];
    if (this.state.BacLuongId && this.state.BacLuongId > 0) {
      var requestData = {
        StoreId: this.state.StoreId,
        BacLuongId: this.state.BacLuongId || 0,
        UserIds: (res.UserId ? [res.UserId] : []),
        Type: flag
      }
      this.props.bacLuongUserUpdateRequest(requestData);
    } else {
      formError.BacLuongId = "Bạn chưa chọn bậc lương";
    }
    this.setState({ formError: formError });
  }
  componentDidMount() {
    this.fetchListBacLuong();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.bacLuongUser.type == bacLuongUserConstant.BACLUONG_USER_DETAIL_SUCCESS) {
      let { listBacLuongActive } = nextProps.bacLuongUser;
      this.setState({
        listBacLuongActive: this.BuildSelectOption(listBacLuongActive)
      });
    } else if (nextProps.bacLuongUser.type == bacLuongUserConstant.BACLUONG_USER_UPDATE_SUCCESS) {
      this.featchDetail();
    } else if (nextProps.bacLuongUser.type == bacLuongUserConstant.BACLUONG_USER_LIST_SUCCESS) {
      let { usersUnset, usersSetted, total_record } = nextProps.bacLuongUser.item;
      this.setState({ usersUnset: usersUnset, usersSetted: usersSetted, total_record: total_record })
    }
  }
  BuildSelectOption(list) {
    var options = [];
    if (list && list.length > 0) {
      list.map((item) => { options.push({ value: item.Id, label: item.Ten }) }
      );
    }
    return options;
  }
  render() {
    const { selectedOption, listBacLuongActive, usersUnset, usersSetted } = this.state;
    const {
      handleSubmit,
      bacLuongUser: {
        listRequesting,
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div className="mb-3">
            <Select
              placeholder="Chọn bậc lương"
              value={selectedOption}
              onChange={this.handleBacLuongChange}
              options={listBacLuongActive}
            />
            <em className="error invalid-feedback">{this.state.formError.BacLuongId}</em>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 row">
              <div className="col-sm-5">
                <InputGroup>
                  <Input placeholder=" Tên, Email, số điện thoại"
                    onChange={this.handleSearchChange.bind(this, "keyword")}
                    onKeyDown={e => this.keyPress(e)} />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" onClick={handleSubmit(this.featchDetail)}>
                      <i className="fa fa-search"></i> Tìm kiếm
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" className="text-center">
                        {usersUnset && !!usersUnset.length && (<CheckboxExt
                          onClick={() => this.checkedUnUserAll()}
                          chkClass="cb-item-all"
                          permission={BtnPermissions.BacLuong.ADD_USERS} />
                        )}
                      </th>
                      <th scope="col" width="120" className="text-left">Mã nhân viên</th>
                      <th scope="col" className="text-left">Tên nhân viên</th>
                      <th scope="col" width="10" className="text-left">Thêm</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usersUnset && !!usersUnset.length && (
                      usersUnset.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td scope="row" className="text-center">
                            <CheckboxExt
                              chkClass="cb-item"
                              onClick={() => this.handleUserClick(res)}
                              checkId={idx + 1}
                              permission={BtnPermissions.BacLuong.ADD_USERS} />
                          </td>
                          <td className="text-left">{res.username}</td>
                          <td className="text-left">{res.TenDayDu} <br></br>  {res.DiaChi ? <span className="item_unit">{res.DiaChi}</span> : null}</td>
                          <td className="text-left">
                            <ButtonExt
                              btnClass="text-primary"
                              iconClass="fa-arrow-right fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateBacLuongUser(res, 0)}
                              permission={BtnPermissions.BacLuong.ADD_USERS} />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                {this.state.total_record > this.state.per_page && (
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total_record}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                )}
              </div>
              <div className="col-sm-2 text-center">
                <Row>
                  <Col sm="12" className="text-center">
                    <ButtonExt btnClass="mr-1"
                      color="success"
                      iconClass="fa fa-arrow-right icon-right"
                      displayText="Thêm"
                      btnClick={() => this.updateUsersSetted("add")}
                      permission={BtnPermissions.BacLuong.ADD_USERS} />
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" className="text-center">
                    <ButtonExt btnClass="mr-1"
                      color="danger"
                      iconClass="fa fa-arrow-left"
                      displayText="&nbsp;&nbsp;&nbsp;Xóa"
                      btnClick={() => this.updateUsersSetted("remove")}
                      permission={BtnPermissions.BacLuong.ADD_USERS} />
                  </Col>
                </Row>
              </div>
              <div className="col-sm-5">
                <InputGroup>
                  <Input placeholder=" Tên, Email, số điện thoại" onChange={this.filterUsersSetted} />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" >
                      <i className="fa fa-search"></i> Tìm kiếm
                      </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="50" className="text-center">Xóa</th>
                      <th scope="col" width="120" className="text-left">Mã nhân viên</th>
                      <th scope="col" className="text-left">Tên nhân viên</th>
                      <th scope="col" width="20" className="text-center">
                        {usersSetted && !!usersSetted.length && (
                          <CheckboxExt
                            onClick={() => this.CheckedUserAll()}
                            chkClass="cb-item-un-all"
                            permission={BtnPermissions.BacLuong.ADD_USERS} />
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {usersSetted && !!usersSetted.length && (
                      usersSetted.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-center">
                            <ButtonExt
                              btnClass="text-danger"
                              iconClass="fa-arrow-left fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateBacLuongUser(res, 1)}
                              permission={BtnPermissions.BacLuong.ADD_USERS} />
                          </td>
                          <td className="text-left">{res.username}</td>
                          <td className="text-left">{res.TenDayDu} <br></br> <span className="item_unit">{res.DiaChi}</span></td>
                          <td scope="row" className="text-center">
                            <CheckboxExt
                              chkClass="cb-item-un"
                              onClick={() => this.handleUnUserClick(res)}
                              checkId={idx + 1}
                              permission={BtnPermissions.BacLuong.ADD_USERS} />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  bacLuongUser: state.bacLuongUser,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  bacLuongUserListRequest: bacLuongUserAction.bacLuongUserListRequest,
  bacLuongUserUpdateRequest: bacLuongUserAction.bacLuongUserUpdateRequest,
  bacLuongUserDetailRequest: bacLuongUserAction.bacLuongUserDetailRequest,
})(BacLuongUser)
const formed = reduxForm({
  form: 'bacLuongUser',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/BacLuong/BacLuongUser.js